// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonIcon_wrapper__p33jh","iconWrapper":"ButtonIcon_iconWrapper__fgsJd"};